import React from 'react';

import { Modal, Button, ToastContext } from '@weezevent/nacre';

import useAppContext from '../../../../context/useAppContext';
import { useTranslation } from 'react-i18next';
import { useUser } from '../../../../simple-connect';
import { fetcher } from '@weezevent/weezjs-core';

export function SendMailAccountActivationModal({ open = false, redirect_uri = null, onSubmit = () => {}, onSave = () => {}, onClose = () => {}, createMode = false }) {
    const { t } = useTranslation();
    const { user } = useUser();
    const toast = React.useContext(ToastContext);

    const [{ organization }] = useAppContext();
    const resendMailAccountActivation = React.useCallback(async () => {
        try {
            await fetcher.post(`/ticket/organizations/${organization.id}/users/${user.user_id}/activation_email`, {
                data: { redirect_uri: redirect_uri || window.location.href }
            });
            toast.success(t('ticket.event.sendMailAccountActivationModal.toast.success'));
        } catch {
            toast.error(t('ticket.event.sendMailAccountActivationModal.toast.error'));
        } finally {
            onClose();
        }
    }, [user, organization, onClose]);

    return (
        <Modal
            allowExternalClosing={false}
            open={open}
            onClose={onClose}
            submitButton={<Button primary label={t('ticket.event.sendMailAccountActivationModal.submitLabel')} onClick={resendMailAccountActivation} />}
            cancelButton={
                <Button
                    onClick={createMode ? onSave : onClose}
                    label={createMode ? t('ticket.event.sendMailAccountActivationModal.saveLabel') : t(`ticket.common.action.cancel`)}
                />
            }
            title={t('ticket.event.sendMailAccountActivationModal.title')}
        >
            <div style={{ marginTop: '15px' }}>{t('ticket.event.sendMailAccountActivationModal.description', { user_mail: user.email })}</div>
        </Modal>
    );
}
